import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="role-selector"
export default class extends Controller {
  static targets = ["socialRole", "roleInput", "couponInput", "couponCarrier"]

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    const roleParam = urlParams.get("role")

    if (roleParam) {
      const radioButton = this.element.querySelector(`input[name="role_toggle"][value="${roleParam}"]`)
      if (radioButton) {
        radioButton.checked = true
      }
    }

    const selected = this.element.querySelector('input[name="role_toggle"]:checked')
    if (selected) {
      this.update({ target: selected })
    }
    this.syncCoupon()
  }

  update(event) {
    const role = event.target.value
    const clientInfo = document.getElementById("client-info")
    const ptInfo = document.getElementById("pt-info")
    const ownerInfo = document.getElementById("owner-info")

    if (role === "pt") {
      clientInfo.classList.add("hidden")
      ptInfo.classList.remove("hidden")
      ownerInfo.classList.add("hidden")
    } else if (role === "gym_owner") {
      clientInfo.classList.add("hidden")
      ptInfo.classList.add("hidden")
      ownerInfo.classList.remove("hidden")
    } else {
      clientInfo.classList.remove("hidden")
      ptInfo.classList.add("hidden")
      ownerInfo.classList.add("hidden")
    }

    if (this.hasRoleInputTarget) {
      this.roleInputTarget.value = role
    }
  }

  syncCoupon() {
    const code = this.hasCouponInputTarget ? this.couponInputTarget.value.trim().toUpperCase() : ""
    this.couponCarrierTargets.forEach((input) => {
      input.value = code
    })
  }
}
